import {
  Box,
  Text,
  Checkbox,
  Flex,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
} from '@chakra-ui/react';
import React from 'react';

import { AthenaTableGQLType } from 'types/dashboard-admin-gqlTypes.generated';

import { TextWithCopy } from 'packages/common-frontend/components/TextWithCopy';

export const AthenaTable = (params: {
  table: AthenaTableGQLType;
  isSelected: boolean;
  onToggleTableSelect: (table: AthenaTableGQLType) => void;
  checkBoxPosition: 'left' | 'right';
}) => {
  const { table, isSelected, onToggleTableSelect, checkBoxPosition } = params;

  return (
    <AccordionItem>
      <Flex justifyContent="space-between" alignItems="center">
        {checkBoxPosition === 'left' && (
          <Flex>
            <Checkbox
              type="checkbox"
              isChecked={isSelected}
              onChange={() => onToggleTableSelect(table)}
              mr="2"
            />
            <AccordionButton p="2">
              <AccordionIcon />
            </AccordionButton>
          </Flex>
        )}
        <Box w="500px">
          <TextWithCopy label={table.tableName} styleProps={{ noOfLines: 1 }}>
            {table.tableName}
          </TextWithCopy>
        </Box>
        {checkBoxPosition === 'right' && (
          <Flex>
            <Checkbox
              type="checkbox"
              isChecked={isSelected}
              onChange={() => onToggleTableSelect(table)}
              mr="2"
            />
            <AccordionButton p="2">
              <AccordionIcon />
            </AccordionButton>
          </Flex>
        )}
      </Flex>

      <AccordionPanel pb={4}>
        {table.properties.map((property) => (
          <Text key={property.name} fontSize="xs">
            {property.name}: {property.type}
          </Text>
        ))}
      </AccordionPanel>
    </AccordionItem>
  );
};
